module.exports = __webpack_public_path__ + "assets/devices/GEN_POWER_SUPPLY-d433b590f3016a342de9371b5adc649e.svg";